import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NavigationUserGroupService} from '../services/navigation-user-group.service';
import {TosterMessageService} from '../services/toster-message.service';
import {AuthenticationService} from '../services/authentication.service';
import {HelperService} from '../services/helper.service';

@Component({
    selector: 'app-redirection',
    templateUrl: './redirection.component.html',
    styleUrls: ['./redirection.component.scss'],
    providers: [ TosterMessageService, AuthenticationService, HelperService]
})
export class RedirectionComponent implements OnInit {
    private id: any;
    pageRedirect: boolean;

    constructor(private route: ActivatedRoute, private authenticationService: AuthenticationService, private helperService: HelperService , private router: Router) {
        this.pageRedirect = false;
        this.route.params.subscribe(params => {
            this.id = +params['id'];
            this.redirectUrl();
            /*get parameter*/
        });

    }

    ngOnInit() {

    }

    redirectUrl() {
        const that = this;
        this.authenticationService
            .loginwithToken()
            .get({'id': that.id})
            .subscribe((data) => {

                that.login(data.data.data.uname, data.data.data.pw);
                this.pageRedirect = false;
            }, (error) => {
                this.pageRedirect = true;
            });
    }

    login(username, password) {
        const that = this;
        this.authenticationService
            .login(username, password)
            .subscribe((data) => {
                this.router.navigate(['dashboard']);

            }, (error) => {
            });
    }

}



// WEBPACK FOOTER //
// /app/src/app/redirection/redirection.component.ts